import React from "react";
import { compose } from "redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Message, Icon } from "semantic-ui-react";
import { withCurrentUser } from "features/../../../shared/components/auth";
import {
  SheetState,
  UserType,
  SheetViewType,
} from "features/../../../shared/constants/enums";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { getSheetDataState } from "../selectors";
import { withImpersonatedPermissions } from "modules/ImpersonatedUserPermissions";

const SheetStatusMessage = ({ currentUser, hasPermission, sheetViewType }) => {
  const {
    isDraft,
    stateIps,
    statePrincipal,
    physicalDocumentSheetStatePrincipal,
    physicalDocumentSheetStateIps,
    submittedForPhysicalDocumentFlow,
  } = useSelector(getSheetDataState);

  const { t } = useTranslation("enums", {
    keyPrefix: process.env.TRADE_AS_IPS
      ? submittedForPhysicalDocumentFlow
        ? "PhysicalDocumentSheetStateIps"
        : "SheetStateIps"
      : submittedForPhysicalDocumentFlow
      ? "PhysicalDocumentSheetStatePrincipal"
      : "SheetStatePrincipal",
  });

  if (isDraft || !currentUser) return null;

  const sheetState = process.env.TRADE_AS_IPS
    ? submittedForPhysicalDocumentFlow
      ? physicalDocumentSheetStateIps
      : stateIps
    : submittedForPhysicalDocumentFlow
    ? physicalDocumentSheetStatePrincipal
    : statePrincipal;

  const isAdmin = hasPermission(Targets.SheetAdmin, Actions.Edit);
  const isInternalUser = currentUser.userType === UserType.HQ;

  return (
    <Message color="orange" icon compact className="sheet-status-message">
      <Icon name={"exclamation"} size="mini" />

      <Message.Content>
        <p>
          {"This sheet's status is "}
          <strong>{t(sheetState)}</strong>
        </p>
        {!isInternalUser &&
          !isAdmin &&
          !(
            sheetViewType === SheetViewType.IpsAdmin ||
            sheetViewType === SheetViewType.SupplierAdmin
          ) && <p>You will not be able to make any further changes.</p>}
      </Message.Content>
    </Message>
  );
};

export default compose(
  withImpersonatedPermissions,
  withCurrentUser,
)(SheetStatusMessage);
